module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-15.ea2c4e56.jpg";